import { render, staticRenderFns } from "./dynamic-menu.vue?vue&type=template&id=acea9f6a&"
import script from "./dynamic-menu.vue?vue&type=script&lang=js&"
export * from "./dynamic-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports